/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterPostBody
 */
export interface RegisterPostBody {
    /**
     * 
     * @type {string}
     * @memberof RegisterPostBody
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterPostBody
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterPostBody
     */
    registrationCode?: string;
}

export function RegisterPostBodyFromJSON(json: any): RegisterPostBody {
    return RegisterPostBodyFromJSONTyped(json, false);
}

export function RegisterPostBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterPostBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'first-name') ? undefined : json['first-name'],
        'lastName': !exists(json, 'last-name') ? undefined : json['last-name'],
        'registrationCode': !exists(json, 'registration-code') ? undefined : json['registration-code'],
    };
}

export function RegisterPostBodyToJSON(value?: RegisterPostBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first-name': value.firstName,
        'last-name': value.lastName,
        'registration-code': value.registrationCode,
    };
}


